// Sentry错误收集，必须最早初始化
import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import './i18n'; // 确保i18n在ConfigProvider之前初始化
import './theme.css';
import './index.css';
import App from './App';
import { client } from './graphql/client';
import { initializeNavBarStyle } from './utils/deviceUtils';
import {CoreModule} from "dynamsoft-core";
import {LicenseManager} from "dynamsoft-license";
import "dynamsoft-barcode-reader";

// debug环境下添加vconsole
if (process.env.NODE_ENV === 'development') {
  import('vconsole').then((VConsole) => {
    new VConsole.default();
  });
}

Sentry.init({
  dsn:"https://cccb39e5464703102941f50bab6a9909@o4509769352478720.ingest.us.sentry.io/4510034094456832",
  // 开启浏览器性能追踪：自动收集页面加载、路由跳转、API请求耗时等性能数据
  integrations: [Sentry.browserTracingIntegration()],
  // 性能数据采样率（生产环境采集20%，避免产生过多数据量）
  tracesSampleRate: 0.2,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// 初始化导航栏样式
initializeNavBarStyle();

CoreModule.engineResourcePaths.rootDirectory = "/static/dynamsoft-barcode-reader-bundle/dist";
LicenseManager.initLicense("DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MTM3NjgyLTEwNDE4NjE0MCIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21kbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwNDEzNzY4MiIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NkbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJjaGVja0NvZGUiOi0zMjgxMDE1NzV9", {
    executeNow: true,
});
CoreModule.loadWasm(["DBR"]);

root.render(
  <div>
    {/*<React.StrictMode>*/}
      <ApolloProvider client={client}>
        <ConfigProvider locale={enUS}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfigProvider>
      </ApolloProvider>
    {/*</React.StrictMode>*/}
  </div>
); 
